import { gql } from 'apollo-angular';

export const AUTHENTICATE_FROM_OKTA = gql`
  mutation AuthenticateFromOkta(
    $aptitudeOrgId: Long
    $vizientBuyerOrgId: String
    $vizientSellerOrgId: String
    $oktaToken: String!
    $acceptedTermsOfUse: Boolean
  ) {
    authenticateFromOkta(
      input: {
        aptitudeOrgId: $aptitudeOrgId
        vizientBuyerOrgId: $vizientBuyerOrgId
        vizientSellerOrgId: $vizientSellerOrgId
        oktaToken: $oktaToken
        acceptedTermsOfUse: $acceptedTermsOfUse
      }
    ) {
      username
      token
      mustAcceptTermsOfUse
    }
  }
`;

export type AuthenticateFromOktaRequest = {
  aptitudeOrgId?: number;
  vizientBuyerOrgId?: string;
  vizientSellerOrgId?: string;
  oktaToken: string;
  acceptedTermsOfUse?: boolean;
};
